import React, { useState } from 'react';
import GenericButton from '../../components/GenericButton';
import GenericInput from '../../components/GenericInput'; // Import the GenericInput component
import { User } from '../../models/Users';

interface AddUserPageProps {
  onSave: (value: any) => void;  // Save callback function
  data: User;  // Game data for editing, possibly null if creating a new user
  action: string;
}

const AddPointsPage: React.FC<AddUserPageProps> = ({ onSave, data, action }) => {
  const [user,  setUser] = useState<User>(data);
  const [point, setPoint] = useState<any>();

  // Form error state
  const [errors, setErrors] = useState({
    point: '',
  });

  // Validation functions
  const validatePoint = (value: string) => {
    return value.trim() === '' ? 'Point is required' : '';
  };

  const handleSubmit = () => {
    // Validate the form
    const pointError = validatePoint(point);

    if (pointError) {
      setErrors({ point: pointError});
      return; // Prevent form submission if there are validation errors
    }

    // If validation passes, trigger the onSave function with the updated user data
    onSave(point);
  };

  return (
    <div className="container mt-4">
      <div className="mb-3">
        <GenericInput
          label="Name"
          disabled={true}
          value={user.name}
          onChange={(e) => setUser({...user, name: e})}
        />
      </div>

      <div className="mb-3">
        <GenericInput
          label="Phone"
          disabled={true}
          value={user.mobile}
          onChange={(e) => setUser({...user, mobile: e})}
          type="text"
        />
      </div>

      <div className="mb-3">
        <GenericInput
          label="Current Points"
          disabled={true}
          value={user.points === null ? 0.0 : user.points.toString()}
          onChange={(e) => {}}
          type="text"
        />
      </div>

      <div className="mb-3">
        <GenericInput
          label={action === 'add' ? "Add Points": 'Remove Points'} 
          value={point}
          onChange={(e) => setPoint(e)}
          type="text"
        />
        {errors.point && <div className="invalid-feedback d-block">{errors.point}</div>}
      </div>


      <GenericButton label={data?.id ? 'Update User' : 'Add User'} onClick={handleSubmit} />
    </div>
  );
};

export default AddPointsPage;
